import React, { useState } from "react";



function File(props) {
  const { items } = props;
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const goToPrevPage = () =>
    setPageNumber(pageNumber - 1 <= 1 ? 1 : pageNumber - 1);

  const goToNextPage = () =>
    setPageNumber(
      pageNumber + 1 >= numPages ? numPages : pageNumber + 1,
    );

  return (
    <div class="mx-2 h-auto">
      {items?.description && <p dangerouslySetInnerHTML={{ __html: items?.description }}></p>}
      {items?.content && <div dangerouslySetInnerHTML={{ __html: items?.content }}></div>}
      <div>
        {items?.file?.path &&
          <div className="h-screen">
            <object data={`${items?.file?.path}`} type="application/pdf" frameborder="0" width="100%" style={{ padding: 2 }}>
              <iframe src={`${items?.file?.path}`} width="100%" style={{ padding: 2 }}></iframe>
            </object>
          </div>
        }
        {/* <Document
          file={{ url: items?.file?.path }}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          <Page pageNumber={pageNumber} />
        </Document> */}
      </div>
    </div>
  );
}

export default File;
